
export default {
  // email: { value: 'ben@tecset.com.au' },
  given_names: { value: 'Benjamin Phillip' },
  last_name: { value: 'Warren' },
  date_of_birth: { value: '1981-10-16' },
  gender: { value: 'Male' },
  address: { value: '3 Henry St, Tighes Hill NSW 2297, Australia' },
  address_addressManualEntry: { value: null },
  address_addressLine1: { value: null },
  address_addressLine2: { value: null },
  address_suburb: { value: null },
  address_state: { value: null },
  address_postcode: { value: null },
  address_country: { value: null },
  phone_number: { value: '0421035676' },
  occupation: { value: null },
  marital_status: { value: 'Married or in a defacto relationship' },
  email__partner: { value: null },
  no_email__partner: { value: 'No Email Address' },
  given_names__partner: { value: 'TestPartner' },
  last_name__partner: { value: 'TestPartner' },
  gender__partner: { value: 'Female' },
  address__partner: { value: null },
  address__partner_addressManualEntry: { value: 'manualEntry' },
  address__partner_addressLine1: { value: '3 Thomas St' },
  address__partner_addressLine2: { value: null },
  address__partner_suburb: { value: 'Islington' },
  address__partner_state: { value: 'NSW' },
  address__partner_postcode: { value: 2296 },
  address__partner_country: { value: 'Australia' },
  same_as_my_address__partner: { value: null },
  email__executor_1: { value: 'test@tecset.com.au' },
  no_email__executor_1: { value: null },
  given_names__executor_1: { value: 'Test Test' },
  last_name__executor_1: { value: 'Test' },
  gender__executor_1: { value: 'Female' },
  address__executor_1: { value: null },
  address__executor_1_addressManualEntry: { value: null },
  address__executor_1_addressLine1: { value: null },
  address__executor_1_addressLine2: { value: null },
  address__executor_1_suburb: { value: null },
  address__executor_1_state: { value: null },
  address__executor_1_postcode: { value: null },
  address__executor_1_country: { value: null },
  same_as_my_address__executor_1: { value: 'Same as my address' },
  add_additional_executor: { value: 'Yes' },
  to_act: { value: 'Jointly' },
  email__executor_2: { value: null },
  no_email__executor_2: { value: 'No Email Address' },
  given_names__executor_2: { value: 'Test2 Test2' },
  last_name__executor_2: { value: 'Test2' },
  gender__executor_2: { value: 'Indeterminate/Intersex/Unspecified' },
  address__executor_2: { value: '3 Thomas St, Islington NSW 2297, Australia' },
  address__executor_2_addressManualEntry: { value: null },
  address__executor_2_addressLine1: { value: null },
  address__executor_2_addressLine2: { value: null },
  address__executor_2_suburb: { value: null },
  address__executor_2_state: { value: null },
  address__executor_2_postcode: { value: null },
  address__executor_2_country: { value: null },
  same_as_my_address__executor_2: { value: null },
  add_additional_executor2: { value: 'No' },
  to_act2: { value: null },
  email__executor_3: { value: null },
  no_email__executor_3: { value: null },
  given_names__executor_3: { value: null },
  last_name__executor_3: { value: null },
  gender__executor_3: { value: null },
  address__executor_3: { value: null },
  address__executor_3_addressManualEntry: { value: null },
  address__executor_3_addressLine1: { value: null },
  address__executor_3_addressLine2: { value: null },
  address__executor_3_suburb: { value: null },
  address__executor_3_state: { value: null },
  address__executor_3_postcode: { value: null },
  address__executor_3_country: { value: null },
  same_as_my_address__executor_3: { value: null },
  do_you_have_any_children: { value: 'Yes' },
  do_you_have_a_child_with_a_disability: { value: 'No' },
  email__child_1: { value: null },
  no_email__child_1: { value: 'No Email Address' },
  given_names__child_1: { value: 'Alex Fox' },
  last_name__child_1: { value: 'Test' },
  gender__child_1: { value: 'Male' },
  address__child_1: { value: null },
  address__child_1_addressManualEntry: { value: null },
  address__child_1_addressLine1: { value: null },
  address__child_1_addressLine2: { value: null },
  address__child_1_suburb: { value: null },
  address__child_1_state: { value: null },
  address__child_1_postcode: { value: null },
  address__child_1_country: { value: null },
  same_as_my_address__child_1: { value: 'Same as my address' },
  do_any_of_the_following_apply_to_child_1: {
    value: ['Child is under the age of 18']
  },
  add_additional_child: { value: 'Yes' },
  email__child_2: { value: null },
  no_email__child_2: { value: 'No Email Address' },
  given_names__child_2: { value: 'TestChild2' },
  last_name__child_2: { value: 'TestChild2' },
  gender__child_2: { value: 'Female' },
  address__child_2: { value: null },
  address__child_2_addressManualEntry: { value: null },
  address__child_2_addressLine1: { value: null },
  address__child_2_addressLine2: { value: null },
  address__child_2_suburb: { value: null },
  address__child_2_state: { value: null },
  address__child_2_postcode: { value: null },
  address__child_2_country: { value: null },
  same_as_my_address__child_2: { value: 'Same as my address' },
  do_any_of_the_following_apply_to_child_2: { value: null },
  add_additional_child2: { value: 'No' },
  email__child_3: { value: null },
  no_email__child_3: { value: null },
  given_names__child_3: { value: null },
  last_name__child_3: { value: null },
  gender__child_3: { value: null },
  address__child_3: { value: null },
  address__child_3_addressManualEntry: { value: null },
  address__child_3_addressLine1: { value: null },
  address__child_3_addressLine2: { value: null },
  address__child_3_suburb: { value: null },
  address__child_3_state: { value: null },
  address__child_3_postcode: { value: null },
  address__child_3_country: { value: null },
  same_as_my_address__child_3: { value: null },
  do_any_of_the_following_apply_to_child_3: { value: null },
  add_additional_child3: { value: null },
  email__child_4: { value: null },
  no_email__child_4: { value: null },
  given_names__child_4: { value: null },
  last_name__child_4: { value: null },
  gender__child_4: { value: null },
  address__child_4: { value: null },
  address__child_4_addressManualEntry: { value: null },
  address__child_4_addressLine1: { value: null },
  address__child_4_addressLine2: { value: null },
  address__child_4_suburb: { value: null },
  address__child_4_state: { value: null },
  address__child_4_postcode: { value: null },
  address__child_4_country: { value: null },
  same_as_my_address__child_4: { value: null },
  do_any_of_the_following_apply_to_child_4: { value: null },
  add_additional_child4: { value: null },
  email__child_5: { value: null },
  no_email__child_5: { value: null },
  given_names__child_5: { value: null },
  last_name__child_5: { value: null },
  gender__child_5: { value: null },
  address__child_5: { value: null },
  address__child_5_addressManualEntry: { value: null },
  address__child_5_addressLine1: { value: null },
  address__child_5_addressLine2: { value: null },
  address__child_5_suburb: { value: null },
  address__child_5_state: { value: null },
  address__child_5_postcode: { value: null },
  address__child_5_country: { value: null },
  same_as_my_address__child_5: { value: null },
  do_any_of_the_following_apply_to_child_5: { value: null },
  add_additional_child5: { value: null },
  email__child_6: { value: null },
  no_email__child_6: { value: null },
  given_names__child_6: { value: null },
  last_name__child_6: { value: null },
  gender__child_6: { value: null },
  address__child_6: { value: null },
  address__child_6_addressManualEntry: { value: null },
  address__child_6_addressLine1: { value: null },
  address__child_6_addressLine2: { value: null },
  address__child_6_suburb: { value: null },
  address__child_6_state: { value: null },
  address__child_6_postcode: { value: null },
  address__child_6_country: { value: null },
  same_as_my_address__child_6: { value: null },
  do_any_of_the_following_apply_to_child_6: { value: null },
  would_you_like_to_name_a_guardians_for_your_childchildren: { value: 'Yes' },
  who_would_you_like_to_appoint_as_a_guardian_of_your_childchildren: {
    value: 'Executor'
  },
  executors__guardian_1: { value: 'Test Test Test' },
  email__guardian_1: { value: null },
  no_email__guardian_1: { value: null },
  given_names__guardian_1: { value: null },
  last_name__guardian_1: { value: null },
  gender__guardian_1: { value: null },
  address__guardian_1: { value: null },
  address__guardian_1_addressManualEntry: { value: null },
  address__guardian_1_addressLine1: { value: null },
  address__guardian_1_addressLine2: { value: null },
  address__guardian_1_suburb: { value: null },
  address__guardian_1_state: { value: null },
  address__guardian_1_postcode: { value: null },
  address__guardian_1_country: { value: null },
  same_as_my_address__guardian_1: { value: null },
  add_additional_guardian: { value: 'Yes' },
  to_act_as: { value: 'Joint Guardian' },
  who_would_you_like_to_appoint_as_a_guardian_of_your_childchildren2: {
    value: 'Other'
  },
  executors__guardian_2: { value: null },
  email__guardian_2: { value: 'billybob@tecset.com.au' },
  no_email__guardian_2: { value: null },
  given_names__guardian_2: { value: 'Billy' },
  last_name__guardian_2: { value: 'Bob' },
  gender__guardian_2: { value: 'Male' },
  address__guardian_2: { value: '1234 Numbers Rd, Suburbville NSW 2300' },
  address__guardian_2_addressManualEntry: { value: null },
  address__guardian_2_addressLine1: { value: null },
  address__guardian_2_addressLine2: { value: null },
  address__guardian_2_suburb: { value: null },
  address__guardian_2_state: { value: null },
  address__guardian_2_postcode: { value: null },
  address__guardian_2_country: { value: null },
  same_as_my_address__guardian_2: { value: null },
  who_do_you_wish_to_receive_your_assets: { value: 'Other' },
  add_beneficiary_other_than_partner_and_children: { value: 'Yes' },
  email__beneficiary_1: { value: 'test3@tecset.com.au' },
  no_email__beneficiary_1: { value: null },
  given_names__beneficiary_1: { value: 'Emma Test' },
  last_name__beneficiary_1: { value: 'Test3' },
  gender__beneficiary_1: { value: 'Female' },
  address__beneficiary_1: { value: '3 Regent St, Mayfield NSW' },
  address__beneficiary_1_addressManualEntry: { value: null },
  address__beneficiary_1_addressLine1: { value: null },
  address__beneficiary_1_addressLine2: { value: null },
  address__beneficiary_1_suburb: { value: null },
  address__beneficiary_1_state: { value: null },
  address__beneficiary_1_postcode: { value: null },
  address__beneficiary_1_country: { value: null },
  same_as_my_address__beneficiary_1: { value: null },
  add_additional_beneficiary: { value: 'Yes' },
  email__beneficiary_2: { value: null },
  no_email__beneficiary_2: { value: 'No Email Address' },
  given_names__beneficiary_2: { value: 'TestBeneficiary2 2' },
  last_name__beneficiary_2: { value: 'TestBeneficiary2' },
  gender__beneficiary_2: { value: 'Male' },
  address__beneficiary_2: {
    value: '1234 Numbers Rd, Suburbville NSW 2300, Australia'
  },
  address__beneficiary_2_addressManualEntry: { value: null },
  address__beneficiary_2_addressLine1: { value: null },
  address__beneficiary_2_addressLine2: { value: null },
  address__beneficiary_2_suburb: { value: null },
  address__beneficiary_2_state: { value: null },
  address__beneficiary_2_postcode: { value: null },
  address__beneficiary_2_country: { value: null },
  same_as_my_address__beneficiary_2: { value: null },
  add_additional_beneficiary2: { value: 'Yes' },
  email__beneficiary_3: { value: null },
  no_email__beneficiary_3: { value: 'No Email Address' },
  given_names__beneficiary_3: { value: 'TestBeneficiary3' },
  last_name__beneficiary_3: { value: 'TestBeneficiary3' },
  gender__beneficiary_3: { value: 'Male' },
  address__beneficiary_3: {
    value: '12 Chalmers Rd, Wallsend NSW 2287, Australia'
  },
  address__beneficiary_3_addressManualEntry: { value: null },
  address__beneficiary_3_addressLine1: { value: null },
  address__beneficiary_3_addressLine2: { value: null },
  address__beneficiary_3_suburb: { value: null },
  address__beneficiary_3_state: { value: null },
  address__beneficiary_3_postcode: { value: null },
  address__beneficiary_3_country: { value: null },
  same_as_my_address__beneficiary_3: { value: null },
  should_any_of_the_following_to_apply_to_your_estate: {
    value: 'unequal distribution'
  },
  person_1: { value: 'Benjamin Phillip Warren' },
  portion_1_: { value: 11.12 },
  add_additional_portion: { value: 'Yes' },
  person_2: { value: 'TestPartner TestPartner' },
  portion_2_: { value: 11.11 },
  add_additional_portion2: { value: 'Yes' },
  person_3: { value: 'Test Test Test' },
  portion_3_: { value: 11.11 },
  add_additional_portion3: { value: 'Yes' },
  person_4: { value: 'Test2 Test2 Test2' },
  portion_4_: { value: 11.11 },
  add_additional_portion4: { value: 'Yes' },
  person_5: { value: 'Alex Fox Test' },
  portion_5_: { value: 11.11 },
  add_additional_portion5: { value: 'Yes' },
  person_6: { value: 'TestChild2 TestChild2' },
  portion_6_: { value: 11.11 },
  add_additional_portion6: { value: 'Yes' },
  person_7: { value: 'Emma Test Test3' },
  portion_7_: { value: 11.11 },
  add_additional_portion7: { value: 'Yes' },
  person_8: { value: 'TestBeneficiary2 2 TestBeneficiary2' },
  portion_8_: { value: 11.11 },
  add_additional_portion8: { value: 'Yes' },
  person_9: { value: 'TestBeneficiary3 TestBeneficiary3' },
  portion_9_: { value: 11.11 },
  add_additional_portion9: { value: 'No' },
  person_10: { value: null },
  portion_10_: { value: null },
  total_: { value: null },
  which_beneficiaries_are_likely_to_be_unable_to_manage_their_financial_affairs_for_any_medical_or_other_reasons: {
    value: null
  },
  do_you_intend_to_leave_specific_gifts_to_individuals: { value: 'Yes' },
  recipient_1: { value: 'Alex Fox Test' },
  gifts_1: { value: 'Maltese Falcon' },
  add_additional_gift: { value: 'No' },
  recipient_2: { value: null },
  gifts_2: { value: null },
  add_additional_gift2: { value: null },
  recipient_3: { value: null },
  gifts_3: { value: null },
  add_additional_gift3: { value: null },
  recipient_4: { value: null },
  gifts_4: { value: null },
  asset_1: { value: 'House' },
  asset_1__description: { value: '3 Henry St, Tighes Hill NSW' },
  asset_1__estimated_value_: { value: 600000 },
  add_additional_asset: { value: 'Yes' },
  asset_2: { value: 'Car' },
  asset_2__description: { value: '2001 Nissan Skyline R34 (CXH42B)' },
  asset_2__estimated_value_: { value: 5000 },
  add_additional_asset2: { value: 'No' },
  asset_3: { value: null },
  asset_3__description: { value: null },
  asset_3__estimated_value_: { value: null },
  add_additional_asset3: { value: null },
  asset_4: { value: null },
  asset_4__description: { value: null },
  asset_4__estimated_value_: { value: null },
  add_additional_asset4: { value: null },
  asset_5: { value: null },
  asset_5__description: { value: null },
  asset_5__estimated_value_: { value: null },
  add_additional_asset5: { value: null },
  asset_6: { value: null },
  asset_6__description: { value: null },
  asset_6__estimated_value_: { value: null },
  add_additional_asset6: { value: null },
  asset_7: { value: null },
  asset_7__description: { value: null },
  asset_7__estimated_value_: { value: null },
  add_additional_asset7: { value: null },
  asset_8: { value: null },
  asset_8__description: { value: null },
  asset_8__estimated_value_: { value: null },
  add_additional_asset8: { value: null },
  asset_9: { value: null },
  asset_9__description: { value: null },
  asset_9__estimated_value_: { value: null },
  add_additional_asset9: { value: null },
  asset_10: { value: null },
  asset_10__description: { value: null },
  asset_10__estimated_value_: { value: null },
  add_additional_asset10: { value: null },
  asset_11: { value: null },
  asset_11__description: { value: null },
  asset_11__estimated_value_: { value: null },
  add_additional_asset11: { value: null },
  asset_12: { value: null },
  asset_12__description: { value: null },
  asset_12__estimated_value_: { value: null },
  liability_1: { value: 'Personal Loan' },
  liability_1__description: { value: 'ABC Bank Acc: 123456789' },
  liability_1__estimated_amount_owing: { value: 5000 },
  add_additional_liability: { value: 'No' },
  liability_2: { value: null },
  liability_2__description: { value: null },
  liability_2__estimated_amount_owing: { value: null },
  add_additional_liability2: { value: null },
  liability_3: { value: null },
  liability_3__description: { value: null },
  liability_3__estimated_amount_owing: { value: null },
  add_additional_liability3: { value: null },
  liability_4: { value: null },
  liability_4__description: { value: null },
  liability_4__estimated_amount_owing: { value: null },
  add_additional_liability4: { value: null },
  liability_5: { value: null },
  liability_5__description: { value: null },
  liability_5__estimated_amount_owing: { value: null },
  add_additional_liability5: { value: null },
  liability_6: { value: null },
  liability_6__description: { value: null },
  liability_6__estimated_amount_owing: { value: null },
  add_additional_liability6: { value: null },
  liability_7: { value: null },
  liability_7__description: { value: null },
  liability_7__estimated_amount_owing: { value: null },
  add_additional_liability7: { value: null },
  liability_8: { value: null },
  liability_8__description: { value: null },
  liability_8__estimated_amount_owing: { value: null },
  add_additional_liability8: { value: null },
  liability_9: { value: null },
  liability_9__description: { value: null },
  liability_9__estimated_amount_owing: { value: null },
  add_additional_liability9: { value: null },
  liability_10: { value: null },
  liability_10__description: { value: null },
  liability_10__estimated_amount_owing: { value: null },
  add_additional_liability10: { value: null },
  liability_11: { value: null },
  liability_11__description: { value: null },
  liability_11__estimated_amount_owing: { value: null },
  add_additional_liability11: { value: null },
  liability_12: { value: null },
  liability_12__description: { value: null },
  liability_12__estimated_amount_owing: { value: null },
  additional_information_you_may_like_to_include: {
    value: ['Add Accountant\'s details']
  },
  name__accountant: { value: null },
  name__accountant_given_names: { value: 'Joe' },
  name__accountant_last_name: { value: 'Bloggs' },
  business_name__accountant: { value: 'Joe Bloggs Accounting' },
  description_of_any_items_being_held_on_my_behalf_by_accountant: {
    value: 'Deed'
  },
  name__financial_planner: { value: null },
  name__financial_planner_given_names: { value: null },
  name__financial_planner_last_name: { value: null },
  business_name__financial_planner: { value: null },
  description_of_any_items_being_held_on_my_behalf_by_my_financial_planner: {
    value: null
  },
  name__solicitorlawyer: { value: null },
  name__solicitorlawyer_given_names: { value: null },
  name__solicitorlawyer_last_name: { value: null },
  businessfirm_name__solicitorlawyer: { value: null },
  description_of_any_items_being_held_on_my_behalf_by_my_former_solicitorlawyer: {
    value: null
  },
  // email__guardian_1: { value: 'testguardian1@tecset.com.au' },
  // no_email__guardian_1: { value: null },
  // given_names__guardian_1: { value: 'Firsteg1 Middleeg1' },
  // last_name__guardian_1: { value: 'Lasteg1' },
  date_of_birth__guardian_1: { value: '2001-01-01' },
  // gender__guardian_1: { value: 'Female' },
  // address__guardian_1: { value: '1 Scott St, Newcastle NSW 2300' },
  // address__guardian_1_addressManualEntry: { value: null },
  // address__guardian_1_addressLine1: { value: null },
  // address__guardian_1_addressLine2: { value: null },
  // address__guardian_1_suburb: { value: null },
  // address__guardian_1_state: { value: null },
  // address__guardian_1_postcode: { value: null },
  // address__guardian_1_country: { value: null },
  // same_as_my_address__guardian_1: { value: null },
  add_additional_enduring_guardian: { value: 'Yes' },
  in_what_capacity_would_you_like_your_enduring_guardians_to_act: {
    value: 'Jointly'
  },
  // email__guardian_2: { value: 'testguardian2@tecset.com.au' },
  // given_names__guardian_2: { value: 'Firsteg2' },
  // last_name__guardian_2: { value: 'Lasteg2' },
  date_of_birth__guardian_2: { value: '1999-12-01' },
  // gender__guardian_2: { value: 'Male' },
  // address__guardian_2: { value: '1234 King St, Newcastle NSW 2300' },
  // address__guardian_2_addressManualEntry: { value: null },
  // address__guardian_2_addressLine1: { value: null },
  // address__guardian_2_addressLine2: { value: null },
  // address__guardian_2_suburb: { value: null },
  // address__guardian_2_state: { value: null },
  // address__guardian_2_postcode: { value: null },
  // address__guardian_2_country: { value: null },
  // same_as_my_address__guardian_2: { value: null },
  add_alternate_enduring_guardian: { value: 'Yes' },
  email__alternate_guardian_1: { value: 'testguardian3@tecset.com.au' },
  no_email__alternate_guardian_1: { value: null },
  given_names__alternate_guardian_1: { value: 'Firsteg3 Middleeg3' },
  last_name__alternate_guardian_1: { value: 'Long de Lasteg3' },
  date_of_birth__alternate_guardian_1: { value: '1981-10-16' },
  gender__alternate_guardian_1: { value: 'Indeterminate/Intersex/Unspecified' },
  address__alternate_guardian_1: { value: '1 Hunter St, Newcastle NSW 2300' },
  address__alternate_guardian_1_addressManualEntry: { value: null },
  address__alternate_guardian_1_addressLine1: { value: null },
  address__alternate_guardian_1_addressLine2: { value: null },
  address__alternate_guardian_1_suburb: { value: null },
  address__alternate_guardian_1_state: { value: null },
  address__alternate_guardian_1_postcode: { value: null },
  address__alternate_guardian_1_country: { value: null },
  same_as_my_address__alternate_guardian_1: { value: null },
  add_additional_alternate_enduring_guardian: { value: null },
  in_what_capacity_would_you_like_your_alternate_enduring_guardians_to_act: {
    value: null
  },
  email__alternate_guardian_2: { value: null },
  no_email__alternate_guardian_2: { value: null },
  given_names__alternate_guardian_2: { value: null },
  last_name__alternate_guardian_2: { value: null },
  date_of_birth__alternate_guardian_2: { value: null },
  gender__alternate_guardian_2: { value: null },
  address__alternate_guardian_2: { value: null },
  address__alternate_guardian_2_addressManualEntry: { value: null },
  address__alternate_guardian_2_addressLine1: { value: null },
  address__alternate_guardian_2_addressLine2: { value: null },
  address__alternate_guardian_2_suburb: { value: null },
  address__alternate_guardian_2_state: { value: null },
  address__alternate_guardian_2_postcode: { value: null },
  address__alternate_guardian_2_country: { value: null },
  same_as_my_address__alternate_guardian_2: { value: null },
  would_you_like_to_create_an_advance_care_directive: { value: 'Yes' },
  i_place_the_following_conditionslimitations_on_my_enduring_guardians: {
    value: ['Other']
  },
  details_of_other_conditionslimitations_on_my_enduring_guardians: {
    value: 'This is a test condition.'
  },
  email__attorney_1: { value: 'testattorney1@tecset.com.au' },
  no_email_address__attorney_1: { value: null },
  given_names__attorney_1: { value: 'Firstat1' },
  last_name__attorney_1: { value: 'Lastat1' },
  gender__attorney_1: { value: 'Female' },
  date_of_birth__attorney_1: { value: '1900-01-01' },
  address__attorney_1: { value: null },
  address__attorney_1_addressManualEntry: { value: null },
  address__attorney_1_addressLine1: { value: null },
  address__attorney_1_addressLine2: { value: null },
  address__attorney_1_suburb: { value: null },
  address__attorney_1_state: { value: null },
  address__attorney_1_postcode: { value: null },
  address__attorney_1_country: { value: null },
  same_as_my_address__attorney_1: { value: 'Same as my address' },
  add_additional_attorney: { value: 'Yes' },
  in_what_capacity_would_you_like_your_attorneys_to_act: {
    value: 'Jointly and Severally (Recommended)'
  },
  email__attorney_2: { value: 'testattorney2@tecset.com.au' },
  no_email_address__attorney_2: { value: null },
  given_names__attorney_2: { value: 'Firstat2 Middleat2' },
  last_name__attorney_2: { value: 'Lastat2' },
  gender__attorney_2: { value: 'Female' },
  date_of_birth__attorney_2: { value: '2000-01-01' },
  address__attorney_2: { value: '123 Hunter St, Newcastle NSW 2300' },
  address__attorney_2_addressManualEntry: { value: null },
  address__attorney_2_addressLine1: { value: null },
  address__attorney_2_addressLine2: { value: null },
  address__attorney_2_suburb: { value: null },
  address__attorney_2_state: { value: null },
  address__attorney_2_postcode: { value: null },
  address__attorney_2_country: { value: null },
  same_as_my_address__attorney_2: { value: null },
  would_you_like_to_appoint_a_substitute_attorney: { value: 'Yes' },
  email__substitute_attorney_1: { value: 'testattorney3@tecset.com.au' },
  no_email_address__substitute_attorney_1: { value: 'No Email Address' },
  given_names__substitute_attorney_1: { value: 'Firstat3' },
  last_name__substitute_attorney_1: { value: 'Lastat3' },
  gender__substitute_attorney_1: {
    value: 'Indeterminate/Intersex/Unspecified'
  },
  date_of_birth__substitute_attorney_1: { value: '1950-12-31' },
  address__substitute_attorney_1: {
    value: '321 King St, Newcastle West NSW 2300'
  },
  address__substitute_attorney_1_addressManualEntry: { value: null },
  address__substitute_attorney_1_addressLine1: { value: null },
  address__substitute_attorney_1_addressLine2: { value: null },
  address__substitute_attorney_1_suburb: { value: null },
  address__substitute_attorney_1_state: { value: null },
  address__substitute_attorney_1_postcode: { value: null },
  address__substitute_attorney_1_country: { value: null },
  same_as_my_address__substitute_attorney_1: { value: null },
  add_additional_substitute_attorney: { value: 'Yes' },
  in_what_capacity_would_you_like_your_substitute_attorneys_to_act: {
    value: 'Jointly'
  },
  email__substitute_attorney_2: { value: 'testattorney4@tecset.com.au' },
  no_email_address__substitute_attorney_2: { value: null },
  given_names__substitute_attorney_2: { value: 'Firstat4 Middleat4' },
  last_name__substitute_attorney_2: { value: 'Lastat4' },
  gender__substitute_attorney_2: { value: 'Female' },
  date_of_birth__substitute_attorney_2: { value: '1980-06-30' },
  address__substitute_attorney_2: { value: null },
  address__substitute_attorney_2_addressManualEntry: { value: null },
  address__substitute_attorney_2_addressLine1: { value: null },
  address__substitute_attorney_2_addressLine2: { value: null },
  address__substitute_attorney_2_suburb: { value: null },
  address__substitute_attorney_2_state: { value: null },
  address__substitute_attorney_2_postcode: { value: null },
  address__substitute_attorney_2_country: { value: null },
  same_as_my_address__substitute_attorney_2: { value: 'Same as my address' },
  additional_powers: {
    value: [
      'I authorise my Attorney(s) to give reasonable gifts',
      'I authorise my Attorney(s) to confer benefits on the following recipients to meet their reasonable living and medical expenses',
      'I authorise my Attorney(s) to receive payment if they act in their Professional capacity',
      'Other'
    ]
  },
  email__benefit_recipient_1: { value: 'testbenrecip1@tecset.com.au' },
  no_email__benefit_recipient_1: { value: null },
  given_names__benefit_recipient_1: { value: 'Firstbr1 Middlebr1' },
  last_name__benefit_recipient_1: { value: 'Lastbr1' },
  gender__benefit_recipient_1: { value: 'Male' },
  address__benefit_recipient_1: { value: null },
  address__benefit_recipient_1_addressManualEntry: { value: null },
  address__benefit_recipient_1_addressLine1: { value: null },
  address__benefit_recipient_1_addressLine2: { value: null },
  address__benefit_recipient_1_suburb: { value: null },
  address__benefit_recipient_1_state: { value: null },
  address__benefit_recipient_1_postcode: { value: null },
  address__benefit_recipient_1_country: { value: null },
  same_as_my_address__benefit_recipient_1: { value: 'Same as my address' },
  add_additional_benefit_recipient: { value: 'Yes' },
  email__benefit_recipient_2: { value: 'testbenrecip2@tecset.com.au' },
  no_email__benefit_recipient_2: { value: null },
  given_names__benefit_recipient_2: { value: 'Firstbr2' },
  last_name__benefit_recipient_2: { value: 'Lastbr2' },
  gender__benefit_recipient_2: { value: 'Female' },
  address__benefit_recipient_2: { value: '1 Scott St Newcastle NSW 2300' },
  address__benefit_recipient_2_addressManualEntry: { value: null },
  address__benefit_recipient_2_addressLine1: { value: null },
  address__benefit_recipient_2_addressLine2: { value: null },
  address__benefit_recipient_2_suburb: { value: null },
  address__benefit_recipient_2_state: { value: null },
  address__benefit_recipient_2_postcode: { value: null },
  address__benefit_recipient_2_country: { value: null },
  same_as_my_address__benefit_recipient_2: { value: null },
  add_additional_benefit_recipient2: { value: 'Yes' },
  email__benefit_recipient_3: { value: 'testbenrecip3@tecset.com.au' },
  no_email__benefit_recipient_3: { value: null },
  given_names__benefit_recipient_3: { value: 'Firstbr3 Middlebr3' },
  last_name__benefit_recipient_3: { value: 'Lastbr3' },
  gender__benefit_recipient_3: { value: 'Indeterminate/Intersex/Unspecified' },
  address__benefit_recipient_3: { value: '1 Hunter St Newcastle NSW 2300' },
  address__benefit_recipient_3_addressManualEntry: { value: null },
  address__benefit_recipient_3_addressLine1: { value: null },
  address__benefit_recipient_3_addressLine2: { value: null },
  address__benefit_recipient_3_suburb: { value: null },
  address__benefit_recipient_3_state: { value: null },
  address__benefit_recipient_3_postcode: { value: null },
  address__benefit_recipient_3_country: { value: null },
  same_as_my_address__benefit_recipient_3: { value: null },
  details_of_other_powers_to_be_granted_to_my_attorneys: {
    value: 'Test power'
  },
  i_place_the_following_conditionslimitations_on_the_authority_of_my_attorneys: {
    value: ['only sell house', 'yearly accounts', 'other']
  },
  // name__accountant: { value: null },
  // name__accountant_given_names: { value: 'Firstac1 Middleac1' },
  // name__accountant_last_name: { value: 'Lastac1' },
  // business_name__accountant: { value: 'Bill\'s Accounting' },
  details_of_other_conditionslimitations_on_the_authority_of_my_attorneys: {
    value: 'Test condition/limitation'
  }
}
